module.exports = __webpack_public_path__ + "static/media/logo-angle.c141c924.png";